import * as actionTypes from "../action-types";
import { getAPI } from '../../utils/api-function';
import { put, takeLeading } from 'redux-saga/effects';
import { get_dashboard, get_recent_activity } from '../../utils/api-routes';

function* getDashboard() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_dashboard);
        console.log("Get Dashboard Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_DASHBOARD, payload: data?.result });
        };
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Dashboard Saga Error ::: ", error);
    }
};

function* getRecentActivity() {
    try {
        const { data } = yield getAPI(get_recent_activity);
        console.log("Recent Activity Saga Response :::", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_RECENT_ACTIVITY, payload: data.result });
        } else {
            yield put({ type: actionTypes.SET_RECENT_ACTIVITY, payload: [] });
        }

    } catch (error) {
        console.log("Get Recent Activity Saga Error :::", error);
        yield put({ type: actionTypes.SET_RECENT_ACTIVITY, payload: [] });
    }
};

export default function* dashboardSaga() {
    yield takeLeading(actionTypes.GET_DASHBOARD, getDashboard);
    yield takeLeading(actionTypes.GET_RECENT_ACTIVITY, getRecentActivity);
};